import { configureStore } from '@reduxjs/toolkit';
import customizationReducer from './customization';
import enumsReducer from './enums';
import roleReducer from './role';
import authReducer from './auth';
import userReducer from './user';
import studentReducer from './student';
import messageReducer from './message';
import cabangReducer from './cabang';
import wilayahReducer from './wilayah';
import sekolahReducer from './sekolah';
import tahunajaranReducer from './tahunajaran';
import jenjangReducer from './jenjang';
import mapelReducer from './mapel';
import mapelbabReducer from './mapelbab';
import hargaReducer from './harga';
import latihanReducer from './latihan';
import materiReducer from './materi';
import videoReducer from './video';
import soalReducer from './soal';
import paymentReducer from './payment';
import fileReducer from './file';
import profileReducer from './profile';
import masterReducer from './master';
import matchwordReducer from './matchword';
import accesscodeReducer from './accesscode';
import parentReducer from './parent';
import studywithmeReducer from './studywithme';
import scheduleReducer from './schedule';
import examarchReducer from './examarch';
import notificationReducer from './notification';
import examtypeReducer from './examtype';
import examScheduleReducer from './examschedule';
import examScoreReducer from './examscore';
import subscriptiontypeReducer from './subscriptiontype';
import schooltypeReducer from './schooltype';
import classtypeReducer from './classtype';
import classscheduleReducer from './classschedule';
import birthdayReducer from './birtday';
import accountingStudentReducer from './accountingStudent';
import verifikasiPembayaranReducer from './verifikasiPembayaran';
import saldoOperasionalReducer from './saldoOperasional';
import pengeluaranOperasionalReducer from './pengeluaranOperasional';
import inputPengeluaranReducer from './inputPengeluaran';
import laporanOperasionalReducer from './laporanOperasional';

// ==============================|| REDUX - MAIN STORE ||============================== //

const reducer = {
  profile: profileReducer,
  auth: authReducer,
  role: roleReducer,
  user: userReducer,
  student: studentReducer,
  latihan: latihanReducer,
  materi: materiReducer,
  matchword: matchwordReducer,
  video: videoReducer,
  payment: paymentReducer,
  soal: soalReducer,
  cabang: cabangReducer,
  jenjang: jenjangReducer,
  mapel: mapelReducer,
  mapelbab: mapelbabReducer,
  sekolah: sekolahReducer,
  harga: hargaReducer,
  tahunajaran: tahunajaranReducer,
  wilayah: wilayahReducer,
  file: fileReducer,
  master: masterReducer,
  message: messageReducer,
  customization: customizationReducer,
  enums: enumsReducer,
  accesscode: accesscodeReducer,
  parent: parentReducer,
  studywithme: studywithmeReducer,
  schedule: scheduleReducer,
  examarch: examarchReducer,
  notification: notificationReducer,
  examtype: examtypeReducer,
  examschedule: examScheduleReducer,
  examscore: examScoreReducer,
  subscriptiontype: subscriptiontypeReducer,
  schooltype: schooltypeReducer,
  classtype: classtypeReducer,
  classschedule: classscheduleReducer,
  birthday: birthdayReducer,
  accountingStudent: accountingStudentReducer,
  verifikasiPembayaran: verifikasiPembayaranReducer,
  saldoOperasional: saldoOperasionalReducer,
  pengeluaranOperasional: pengeluaranOperasionalReducer,
  inputPengeluaran: inputPengeluaranReducer,
  laporanOperasional: laporanOperasionalReducer
};
export const store = configureStore({
  reducer: reducer,
  devTools: true
});
